import { downloadFileFromS3 } from "@erp/shared/api/generated/wrappers/s3";
import axios from "axios";
import { extractOriginalName } from "./file-name";
/**
 * @description mux 파일 다운로드 함수를 사용하기 편하게 래핑한 함수 (지양 -> 없애고 downloadFileByKey 사용 권장)
 *
 * @param {string | null} foldername
 * @param {string | null} fileName
 */
export async function downloadFile(folderName, fileName) {
    if (!folderName || !fileName) {
        throw new Error("다운로드에 필요한 file과 foldername이 없습니다.");
    }
    // fileName에 이미 폴더 경로가 포함되어 있는지 확인
    const key = fileName.startsWith(folderName)
        ? fileName
        : `${folderName}/${fileName}`;
    const originFileName = extractOriginalName(fileName);
    const { url } = await downloadFileFromS3(key, originFileName);
    await axios.get(url, { responseType: "blob" }).then((res) => {
        const objectUrl = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = originFileName; // 파일 이름
        a.click();
        URL.revokeObjectURL(objectUrl);
    });
}
/**
 * @description 파일 key로 S3에서 파일을 다운로드 하는 함수
 *
 * @param {string | null} key
 */
export async function downloadFileByKey(key) {
    if (!key) {
        throw new Error("다운로드에 필요한 file key가 없습니다.");
    }
    const originFileName = extractOriginalName(key);
    const { url } = await downloadFileFromS3(key, originFileName);
    await axios.get(url, { responseType: "blob" }).then((res) => {
        const objectUrl = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = originFileName; // 파일 이름
        a.click();
        URL.revokeObjectURL(objectUrl);
    });
}
